import { useCallback } from "react";

import { useCheckInAvailableDayOfTheWeek } from "@/components/features/items/edit/plan/_shared/ui/components/term/check-in-available-day-of-the-week/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanCheckInAvailableDayOfTheWeek = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { checkInAvailableDayOfTheWeek } = viewModel;

	const isHolidayCheckInAvailable = viewModel.isHolidayCheckInAvailable?.value ?? undefined;

	const onSetIsHolidayCheckInAvailable = useCallback(
		(value: boolean | undefined) => {
			onSetViewModel([
				{
					key: "isHolidayCheckInAvailable",
					value: {
						isEdited: true,
						value: value ?? null,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		...useCheckInAvailableDayOfTheWeek({ checkInAvailableDayOfTheWeek, onSetViewModel }),
		isHolidayCheckInAvailable,
		onSetIsHolidayCheckInAvailable,
	};
};
